export function parsePriceValue(value) {
  if (value === null || value === undefined || value === '') return 0;
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;

  const normalized = String(value).replace(/[^0-9.,-]/g, '').replace(/,/g, '');
  const amount = parseFloat(normalized);
  return Number.isFinite(amount) ? amount : 0;
}

export function getCartTotals(selectedProductsOrItems) {
  const items = Array.isArray(selectedProductsOrItems)
    ? selectedProductsOrItems
    : Object.values(selectedProductsOrItems || {});

  return items.reduce((totals, item) => {
    const quantity = Math.max(1, Number(item.quantity) || 1);
    const unitPrice = parsePriceValue(item.price);

    totals.selectedCount += 1;
    totals.totalQuantity += quantity;
    totals.totalAmount += unitPrice * quantity;
    return totals;
  }, {
    selectedCount: 0,
    totalQuantity: 0,
    totalAmount: 0
  });
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2
  }).format(amount || 0);
}
